import { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { LoadingState } from '../routes/components/LoadingState'
import { useAuth } from './AuthContext'

export function AuthCallbackPage() {
  const { completeSignIn } = useAuth()
  const navigate = useNavigate()
  const started = useRef(false)
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    if (started.current) return
    started.current = true
    void completeSignIn()
      .then((returnTo) => navigate(returnTo, { replace: true }))
      .catch(() => {
        window.history.replaceState({}, document.title, '/auth/callback')
        setFailed(true)
      })
  }, [completeSignIn, navigate])

  if (failed) {
    return (
      <main className="auth-screen" role="alert">
        <div className="auth-backdrop" aria-hidden="true" />
        <section className="auth-card">
          <img className="auth-logo" src="/brand/logo.svg" alt="" />
          <h1>Sign in didn’t finish</h1>
          <p>The sign-in link expired or was opened twice. Start again — it only takes a second.</p>
          <button type="button" onClick={() => navigate('/auth', { replace: true })}>
            Try again
          </button>
        </section>
      </main>
    )
  }
  return <LoadingState label="Signing you in…" />
}
